import { apiClient } from "../../../lib/apiClient"
import type { ApiResponse } from "../../../types/apiResponse";
import type { ClientData } from "../types";


export const fetchClients = async () => {
  return apiClient<ApiResponse<ClientData[]>>('/v1/clients', {
    method: "GET"
  });
}
